import { api } from "@/api"
import { queryClient } from "@/queryClient"

type CreateImportResponse = {
  id: string
}

export const createImport = async (file: File) => {
  const formData = new FormData()
  formData.append("file", file, file.name)
  const { body } = await api.post<CreateImportResponse>(
    "/imports/",
    {
      body: formData,
    }
  )
  queryClient.invalidateQueries({
    queryKey: [BASE_PRODUCT_IMPORT_QUERY_KEY],
  })
  return body
}
